import { useState, useEffect } from "react";
import { getDefaultAvatarForTitle } from "../utils/avatarUtils";

/**
 * Returns the active profile picture for the current user.
 *
 * Priority:
 * 1. User's own uploaded photo (localStorage "profilePicture")
 * 2. School logo (tenant.logo_url) – acts as the school-branded default
 * 3. Generic silhouette avatar
 */
export const useProfilePic = () => {
  const getEffectivePic = () => {
    const personal = localStorage.getItem("profilePicture");
    if (personal) return personal;
    const title = localStorage.getItem("userTitle");
    return getDefaultAvatarForTitle(title);
  };

  const [profilePic, setProfilePic] = useState<string>(getEffectivePic);

  // Re-evaluate when tenant data loads / changes
  useEffect(() => {
    setProfilePic(getEffectivePic());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Re-evaluate when localStorage changes (e.g. user uploads a new photo)
  useEffect(() => {
    const handleStorageChange = () => {
      setProfilePic(getEffectivePic());
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return profilePic;
};
